import React from 'react';
import cn from '@/utils/cn';
import { IAnalyticRubricCriterion, IAnalyticRubricLevel } from '../../useQuestionRubric';
import styles from './AnalyticRubric.module.scss';

type PreviewLevelDescriptionCellProps = {
  criterionData: IAnalyticRubricCriterion;
  locale?: Lowercase<Locale>;
  score: number;
};

const PreviewLevelDescriptionCell = ({
  criterionData,
  locale = 'en',
  score,
}: PreviewLevelDescriptionCellProps) => {
  const level = criterionData.levels.find((lvl: IAnalyticRubricLevel) => lvl.score === score);
  const description = (locale === 'en' ? level?.description_en : level?.description_es) ?? '';

  return (
    <div
      className={cn('allow-list-style', styles.analyticDescriptionCell)}
      dangerouslySetInnerHTML={{ __html: description }}
    />
  );
};

export default PreviewLevelDescriptionCell;
